import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import orderService from '../../services/orderService';

export const fetchOrders = createAsyncThunk('orders/fetchOrders', async (filters, thunkAPI) => {
  try { return await orderService.list(filters || {}); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

export const fetchOrder = createAsyncThunk('orders/fetchOrder', async (id, thunkAPI) => {
  try { return await orderService.get(id); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

export const createOrder = createAsyncThunk('orders/createOrder', async (payload, thunkAPI) => {
  try { return await orderService.create(payload); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

export const updateOrder = createAsyncThunk('orders/updateOrder', async ({ id, payload }, thunkAPI) => {
  try { return await orderService.update(id, payload); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

export const updateOrderStatus = createAsyncThunk('orders/updateOrderStatus', async ({ id, status }, thunkAPI) => {
  try { return await orderService.updateStatus(id, status); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

const initialState = {
  orders: [],
  order: null,
  filters: { page: 1, limit: 20, sortBy: 'orderDate', sortDir: 'desc' },
  pagination: { totalPages: 0, currentPage: 1, total: 0 },
  isLoading: false,
  isError: false,
  message: '',
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setFilters(state, action) { state.filters = { ...state.filters, ...(action.payload || {}) }; },
    resetOrderState() { return initialState; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => { state.isLoading = true; state.isError = false; state.message = ''; })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.isLoading = false; state.isError = false;
        const { orders, totalPages, currentPage, total } = action.payload;
        state.orders = orders || [];
        state.pagination = { totalPages, currentPage, total };
      })
      .addCase(fetchOrders.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload || 'Failed to load orders'; })
      .addCase(fetchOrder.pending, (state) => { state.isLoading = true; state.isError = false; state.message = ''; })
      .addCase(fetchOrder.fulfilled, (state, action) => { state.isLoading = false; state.order = action.payload; })
      .addCase(fetchOrder.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload || 'Failed to load order'; })
      .addCase(createOrder.fulfilled, (state, action) => { state.orders.unshift(action.payload); })
      .addCase(updateOrder.fulfilled, (state, action) => {
        state.order = action.payload; const idx = state.orders.findIndex(o => o._id === action.payload._id); if (idx >= 0) state.orders[idx] = action.payload;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.order = action.payload; const idx = state.orders.findIndex(o => o._id === action.payload._id); if (idx >= 0) state.orders[idx] = action.payload;
      });
  }
});

export const { setFilters, resetOrderState } = orderSlice.actions;
export default orderSlice.reducer;
